import { forwardRef, type InputHTMLAttributes } from 'react';

export interface RangeSliderProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange' | 'value' | 'min' | 'max' | 'step'> {
  value: number;
  min: number;
  max: number;
  step: number;
  /** Required: a slider has no visible text of its own, so it needs an accessible name. */
  'aria-label': string;
  onValueChange: (value: number) => void;
}

/**
 * A native range slider in the design-system accent colour. Presentational only
 * (no domain knowledge), so the image-crop dialog's zoom control - and any later
 * slider - shares one control instead of a raw `<input type="range">`.
 */
export const RangeSlider = forwardRef<HTMLInputElement, RangeSliderProps>(function RangeSlider(
  { value, min, max, step, onValueChange, className = '', ...rest },
  ref,
) {
  return (
    <input
      {...rest}
      ref={ref}
      type="range"
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={(event) => onValueChange(Number(event.target.value))}
      className={`h-2 w-full cursor-pointer accent-green disabled:cursor-not-allowed ${className}`.trim()}
    />
  );
});
